import React from 'react';
import Modal from 'react-modal';
export let lastModalTargetId = null;
export const APP_ID = 'modalAppId';
let count = 0;

export default class ModalTarget extends React.Component {
  constructor(props) {
    super(props);
    /* This addresses issues with each page having its own modal
     * target. Need to not reuse IDs so both can be active at once.
     */
    const id = `modalTargetId${count++}`;
    lastModalTargetId = id;
    this.modalTargetId = id;
  }

  componentDidMount() {
    this.lookForApp();
  }

  lookForApp() {
    const el = document.getElementById(APP_ID);
    if (el) {
      Modal.setAppElement(`#${APP_ID}`);
    } else {
      setTimeout(() => this.lookForApp(), 100);
    }
  }

  render() {
    return <div id={this.modalTargetId} />;
  }
}
